import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "dialog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PickerHeader = _resolveComponent("PickerHeader")!
  const _component_PickerControls = _resolveComponent("PickerControls")!
  const _component_YearGrid = _resolveComponent("YearGrid")!
  const _component_SeasonGrid = _resolveComponent("SeasonGrid")!
  const _component_MonthGrid = _resolveComponent("MonthGrid")!

  return (_openBlock(), _createElementBlock("div", {
    class: "custom-date-picker",
    "data-testid": `${_ctx.testid}-custom-picker`
  }, [
    _createVNode(_component_PickerHeader, {
      label: _ctx.formattedDateString,
      testid: _ctx.testid
    }, null, 8, ["label", "testid"]),
    _createVNode(_component_PickerControls, {
      type: _ctx.type,
      testid: _ctx.testid,
      "formatted-year": _ctx.formattedYear,
      "formatted-month": _ctx.formattedMonth,
      "formatted-season": _ctx.formattedSeason,
      "can-shift-month-prev": _ctx.canShiftMonthPrev,
      "can-shift-month-next": _ctx.canShiftMonthNext,
      "can-shift-season-prev": _ctx.canShiftSeasonPrev,
      "can-shift-season-next": _ctx.canShiftSeasonNext,
      "can-shift-year-prev": _ctx.canShiftYearPrev,
      "can-shift-year-next": _ctx.canShiftYearNext,
      "can-shift-view-year-prev": _ctx.canShiftViewYearPrev,
      "can-shift-view-year-next": _ctx.canShiftViewYearNext,
      onShiftYear: _ctx.shiftYear,
      onShiftViewYear: _ctx.shiftViewYear,
      onShiftMonth: _ctx.shiftMonth,
      onShiftSeason: _ctx.shiftSeason,
      onToggleView: _ctx.toggleView
    }, null, 8, ["type", "testid", "formatted-year", "formatted-month", "formatted-season", "can-shift-month-prev", "can-shift-month-next", "can-shift-season-prev", "can-shift-season-next", "can-shift-year-prev", "can-shift-year-next", "can-shift-view-year-prev", "can-shift-view-year-next", "onShiftYear", "onShiftViewYear", "onShiftMonth", "onShiftSeason", "onToggleView"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.openView === 'year')
        ? (_openBlock(), _createBlock(_component_YearGrid, {
            key: 0,
            modelValue: _ctx.pickerOpen,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickerOpen) = $event)),
            testid: _ctx.testid,
            "allowed-years": _ctx.years,
            selected: _ctx.selectedYear,
            onSelect: _ctx.onYearSelect
          }, null, 8, ["modelValue", "testid", "allowed-years", "selected", "onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.type === 'season' && _ctx.openView === 'season')
        ? (_openBlock(), _createBlock(_component_SeasonGrid, {
            key: 1,
            testid: _ctx.testid,
            seasons: _ctx.seasons,
            selected: _ctx.selectedSeason,
            locale: _ctx.locale,
            "is-disabled": _ctx.isSeasonDisabled,
            "view-year": _ctx.viewYear,
            "selected-year": _ctx.selectedYear,
            onSelect: _ctx.onSeasonSelect
          }, null, 8, ["testid", "seasons", "selected", "locale", "is-disabled", "view-year", "selected-year", "onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.type === 'month' && _ctx.openView === 'month')
        ? (_openBlock(), _createBlock(_component_MonthGrid, {
            key: 2,
            testid: _ctx.testid,
            selected: _ctx.selectedMonth,
            locale: _ctx.locale,
            "is-disabled": _ctx.isMonthDisabled,
            "view-year": _ctx.viewYear,
            "selected-year": _ctx.selectedYear,
            onSelect: _ctx.onMonthSelect
          }, null, 8, ["testid", "selected", "locale", "is-disabled", "view-year", "selected-year", "onSelect"]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}